var swiper = new Swiper(".mySwiper", {
      slidesPerView: 1,
      spaceBetween: 30,
   loop: true,
  autoplay: {
        delay: 7000,
        disableOnInteraction: false,
      },
  navigation: {
        nextEl: ".arrow-righttt",
        prevEl: ".arrow-lefttt",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });


// $('.announcement-main').show();    
document.querySelectorAll('.announcement-main').forEach(function(el) {
  el.style.display = '';
});
  
//   $('#my-keen-slider').marquee({
//    direction: 'left',
//     duration: 25000,
//     gap: 0,
//     delayBeforeStart: 0,
//     duplicated: true,
//     startVisible: true
// });

document.querySelectorAll(".BSP_swiper").forEach(function (el) {
  var container = el.closest(".page-width") || el.parentElement;
  new Swiper(el, {
    slidesPerView: "auto",
    spaceBetween: 26,
    navigation: {
      nextEl: container.querySelector(".arrow-right"),
      prevEl: container.querySelector(".arrow-left"),
    },
    breakpoints: {
      320: {
        spaceBetween: 10,
        pagination: {
          el: container.querySelector(".swiper-pagination"),
        },
      },
      550: {
        spaceBetween: 16,
      },
      750: {
        spaceBetween: 26,
      },
      1200: {
        spaceBetween: 33,
      },
    },
  });
});


 var play_box_Swiper = new Swiper(".play-product", {
      slidesPerView: "auto",
      spaceBetween: 25,
   slidesPerGroup: 1,
   navigation: {
        nextEl: ".play_arrow-right",
        prevEl: ".play_arrow-left",
      },
    breakpoints: {        
        550: {
          spaceBetween: 44,   
          slidesPerGroup: 4,
        },
      },
    });



 var tab_Swiper = new Swiper(".tab_Swiper", {
      slidesPerView: "auto",
      spaceBetween: 16,
       navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },   
  breakpoints: {        
        750: {
          spaceBetween: 38,         
        },
      }
   }
    );

var Collection_link = new Swiper(".Collection-link", {
      slidesPerView: "auto",
      spaceBetween: 0,
       navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },   
  breakpoints: {        
        750: {
          spaceBetween: 38,         
        },
      },
   }
    );


// Code for tab Active And Slide

// var index_value=jQuery('.data_active').length;
// if(index_value > 0)
// {
//   var index_value=jQuery('.data_active').attr('data_id');
//   Collection_link.slideTo(index_value);
  
// }

var dataActive = document.querySelector('.data_active');
if (dataActive) {
  var index_value = dataActive.getAttribute('data_id');
  Collection_link.slideTo(index_value);
}


// End Code for tab Active And Slide





var Tab_swiper = new Swiper(".tab_pro_slider", {
      slidesPerView: "auto",
      spaceBetween: 10, 
  navigation: {
        nextEl: ".arrow-right_teb",
        prevEl: ".arrow-left_teb",
      },  
  breakpoints: {
        750: {
          spaceBetween: 33,         
        },
  }
    });


// $(document).ready(function() {
//     $('ul.tabs').each(function(){
//       var active, content, links = $(this).find('a');
//       active = links.first().addClass('active');
//       content = $(active.attr('href'));
//       links.not(':first').each(function () {
//         $($(this).attr('href')).hide();
//       });
//       $(this).find('a').click(function(e){




//         let page = __st.p;
//   let sectionTitle = "curate your hair care"
//   let TabTitle = jQuery(this).find('span').text().trim();

//   let data = {
//     section_name: sectionTitle,
//     tab_name: TabTitle,
//     pagename: page,
//   };

//   let eventObj = {
//     eventName: "COLLECTION TAB",
//     eventData: data,
//   };

//   //console.log("------//------", eventObj);
//      Shopify.analytics.publish('percept_custom_event', eventObj);
        





        
//         active.removeClass('active');
//         content.hide();
//         active = $(this);
//         content = $($(this).attr('href'));
//         active.addClass('active');
//         content.show();
//         return false;
//       });
//     });
//   //initComparisons();
  
//   });


// //   document.querySelectorAll('ul.tabs').forEach(function(tabList) {
// //     const links = tabList.querySelectorAll('a');
// //     // Set first tab as active
// //     links.forEach(function(link, idx) {
// //       if (idx === 0) link.classList.add('active');
// //       else link.classList.remove('active');
// //     });

// //     // Hide all tab content except the first
// //     links.forEach(function(link, idx) {
// //       const tabContent = document.querySelector(link.getAttribute('href'));
// //       if (tabContent) tabContent.style.display = idx === 0 ? '' : 'none';
// //     });

// //     links.forEach(function(link) {
// //       link.addEventListener('click', function(e) {
// //         e.preventDefault();

// //         // Remove active from all tabs and hide all content
// //         links.forEach(function(l) {
// //           l.classList.remove('active');
// //           const c = document.querySelector(l.getAttribute('href'));
// //           if (c) c.style.display = 'none';
// //         });

// //         // Set active on clicked tab and show its content
// //         link.classList.add('active');
// //         const content = document.querySelector(link.getAttribute('href'));
// //         if (content) content.style.display = '';

// //         // --- Analytics event (same as your jQuery code) ---
// //         let page = window.__st && __st.p ? __st.p : '';
// //         let sectionTitle = "curate your hair care";
// //         let TabTitle = link.querySelector('span') ? link.querySelector('span').textContent.trim() : '';
// //         let data = {
// //           section_name: sectionTitle,
// //           tab_name: TabTitle,
// //           pagename: page,
// //         };
// //         let eventObj = {
// //           eventName: "COLLECTION TAB",
// //           eventData: data,
// //         };
// //         if (window.Shopify && Shopify.analytics) {
// //           Shopify.analytics.publish('percept_custom_event', eventObj);
// //         }
// //         // --- End analytics event ---
// //       });
// //     });
// //   });
// // });


// Robust DOM ready handler for dynamic script loading
function onDomReady(fn) {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", fn);
  } else {
    fn();
  }
}

onDomReady(function () {

  document.querySelectorAll('ul.tabs').forEach(function(tabList) {
    const links = tabList.querySelectorAll('a');
    let active = links[0];
    active.classList.add('active');
    let content = document.querySelector(active.getAttribute('href'));
    // Hide all except the first
    links.forEach(function(link, idx) {
      const tabContent = document.querySelector(link.getAttribute('href'));
      if (tabContent && idx !== 0) tabContent.style.display = 'none';
      link.addEventListener('click', function(e) {
        e.preventDefault();

        // --- Analytics event (same as your jQuery code) ---
        let page = window.__st && __st.p ? __st.p : '';
        let sectionTitle = "curate your hair care";
        let TabTitle = link.querySelector('span') ? link.querySelector('span').textContent.trim() : '';
        let data = {
          section_name: sectionTitle,
          tab_name: TabTitle,
          pagename: page,
        };
        let eventObj = {
          eventName: "COLLECTION TAB",
          eventData: data,
        };
        if (window.Shopify && Shopify.analytics) {
          Shopify.analytics.publish('percept_custom_event', eventObj);
        }
        // --- End analytics event ---

        // Tab switching logic
        active.classList.remove('active');
        if (content) content.style.display = 'none';
        active = link;
        content = document.querySelector(link.getAttribute('href'));
        active.classList.add('active');
        if (content) content.style.display = '';
        return false;
      });
    });
  });

});





  var mySwiper_fade = new Swiper(".mySwiper_fade", {
      spaceBetween: 30,
      effect: "fade",
    autoplay: {
        delay: 1500,
        disableOnInteraction: false,
      },
      loop:true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });









// $(document).ready(function() {
//   let isLoading = false;  

//    $(window).scroll(function() {
//       var check_scroll=jQuery('.js-load-more').attr('data-load');
//       if(typeof check_scroll != "undefined" || check_scroll != null)
//       {
//         if($(window).width()<=800)
//         {
//           var height_val=5000;
//         }else
//         {
//           var height_val=3500;
//         }
        
        
//                if ($(window).scrollTop() + $(window).height() >= $(document).height() - parseInt(height_val) && !isLoading) {
//                 isLoading = true;
//                  var __this = $(".js-load-more"),
//                   totalPages = parseInt($('[data-all-pages]').val()),
//                   currentPage = parseInt($("[data-this-page]").val()),
//                   datacollurl = $("[data-coll-url]").val();
//                 __this.attr("disabled", true);
//                 __this.find("[load-more-text]").addClass("hide");
//                 __this.find("[loader]").removeClass("hide");
                
//                 var nextUrl = $('.next_url').attr('value');
                
//                 var current_page_new = currentPage + 1;
//                 var next_coll = currentPage + 2;
//                 //alert(current_page_new);
//                 //return false;
//                 $.ajax({
//                   url: nextUrl,
//                   type: "GET",
//                   dataType: "html",
//                   success: function (responseHTML) {
                    
//                     $("[data-next-url]").val(datacollurl + "?page=" + next_coll);
//                     $("[data-this-page]").val(current_page_new);
                     
//                       if(typeof responseHTML != "undefined" || responseHTML != null)
//                     {
//                     var productsHtml = $(responseHTML).find('.collection_product-grid li'); 
                    
//                       $(".collection_product-grid").append(productsHtml);
//                     }
//                     isLoading=false;
//                   },
//                   complete: function () {
//                     if (current_page_new < totalPages) {
//                       __this.attr("disabled", false);
//                       __this.find("[load-more-text]").removeClass("hide");
//                       __this.find("[loader]").addClass("hide");
//                     }
//                     if (current_page_new >= totalPages) {
//                       __this.find("[load-more-text]").text("Products Finished").removeClass("hide");
//                       __this.find("[loader]").addClass("hide");
                      
//                     }
//                   },
//                 });
                
//               }
//         }  
//    });

// });

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", function () {
    setupInfiniteScroll();
  });
} else {
  setupInfiniteScroll();
}

function setupInfiniteScroll() {
  let isLoading = false;

  window.addEventListener('scroll', function () {
    const loadMoreBtn = document.querySelector('.js-load-more');
    if (!loadMoreBtn) return;

    const check_scroll = loadMoreBtn.getAttribute('data-load');
    if (typeof check_scroll === "undefined" || check_scroll === null) return;

    const height_val = window.innerWidth <= 800 ? 5000 : 3500;

    if ((window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - height_val) && !isLoading) {
      isLoading = true;

      const totalPages = parseInt(document.querySelector('[data-all-pages]')?.value || '1');
      const currentPage = parseInt(document.querySelector('[data-this-page]')?.value || '1');
      const datacollurl = document.querySelector('[data-coll-url]')?.value || '';
      loadMoreBtn.setAttribute("disabled", true);

      const loadMoreText = loadMoreBtn.querySelector('[load-more-text]');
      const loader = loadMoreBtn.querySelector('[loader]');
      if (loadMoreText) loadMoreText.classList.add('hide');
      if (loader) loader.classList.remove('hide');

      const nextUrl = document.querySelector('.next_url')?.value || '';
      const current_page_new = currentPage + 1;
      const next_coll = currentPage + 2;

      fetch(nextUrl)
        .then(response => response.text())
        .then(responseHTML => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(responseHTML, 'text/html');
          const productsHtml = doc.querySelectorAll('.collection_product-grid li');
          const grid = document.querySelector('.collection_product-grid');
          productsHtml.forEach(li => grid.appendChild(li));

          const nextUrlInput = document.querySelector('[data-next-url]');
          const thisPageInput = document.querySelector('[data-this-page]');
          if (nextUrlInput) nextUrlInput.value = datacollurl + "?page=" + next_coll;
          if (thisPageInput) thisPageInput.value = current_page_new;
        })
        .finally(() => {
          if (current_page_new < totalPages) {
            loadMoreBtn.removeAttribute("disabled");
            if (loadMoreText) loadMoreText.classList.remove('hide');
            if (loader) loader.classList.add('hide');
          }
          if (current_page_new >= totalPages) {
            if (loadMoreText) {
              loadMoreText.textContent = "Products Finished";
              loadMoreText.classList.remove('hide');
            }
            if (loader) loader.classList.add('hide');
          }
          isLoading = false;
        });
    }
  });
}


// $(".js-load-more").on("click", function () {
//   jQuery(this).attr('data-load',true);
//   var __this = $(this),
//     totalPages = parseInt($('[data-all-pages]').val()),
//     currentPage = parseInt($("[data-this-page]").val()),
//     datacollurl = $("[data-coll-url]").val();
//   __this.attr("disabled", true);
//   __this.find("[load-more-text]").addClass("hide");
//   __this.find("[loader]").removeClass("hide");
  
//   var nextUrl = $('.next_url').attr('value');
  
//   var current_page_new = currentPage + 1;
//   var next_coll = currentPage + 2;
//   //alert(current_page_new);
//   //return false;
//   $.ajax({
//     url: nextUrl,
//     type: "GET",
//     dataType: "html",
//     success: function (responseHTML) {
      
//       $("[data-next-url]").val(datacollurl + "?page=" + next_coll);
//       $("[data-this-page]").val(current_page_new);
       
//       var productsHtml = $(responseHTML).find('.collection_product-grid li'); 
//       $(".collection_product-grid").append(productsHtml);
//     },
//     complete: function () {
//       if (current_page_new < totalPages) {
//         __this.attr("disabled", false);
//         __this.find("[load-more-text]").removeClass("hide");
//         __this.find("[loader]").addClass("hide");
//       }
//       if (current_page_new >= totalPages) {
//         __this.find("[load-more-text]").text("Products Finished").removeClass("hide");
//         __this.find("[loader]").addClass("hide");
        
//       }
//     },
//   });
// });


document.querySelectorAll('.js-load-more').forEach(function(loadMoreBtn) {
  loadMoreBtn.addEventListener('click', function () {
    loadMoreBtn.setAttribute('data-load', true);

    const totalPages = parseInt(document.querySelector('[data-all-pages]')?.value || '1');
    const currentPage = parseInt(document.querySelector('[data-this-page]')?.value || '1');
    const datacollurl = document.querySelector('[data-coll-url]')?.value || '';
    loadMoreBtn.setAttribute("disabled", true);

    const loadMoreText = loadMoreBtn.querySelector('[load-more-text]');
    const loader = loadMoreBtn.querySelector('[loader]');
    if (loadMoreText) loadMoreText.classList.add('hide');
    if (loader) loader.classList.remove('hide');

    const nextUrl = document.querySelector('.next_url')?.value || '';
    const current_page_new = currentPage + 1;
    const next_coll = currentPage + 2;

    fetch(nextUrl)
      .then(response => response.text())
      .then(responseHTML => {
        // Update next/this page values
        const nextUrlInput = document.querySelector('[data-next-url]');
        const thisPageInput = document.querySelector('[data-this-page]');
        if (nextUrlInput) nextUrlInput.value = datacollurl + "?page=" + next_coll;
        if (thisPageInput) thisPageInput.value = current_page_new;

        // Parse and append new products
        const parser = new DOMParser();
        const doc = parser.parseFromString(responseHTML, 'text/html');
        const productsHtml = doc.querySelectorAll('.collection_product-grid li');
        const grid = document.querySelector('.collection_product-grid');
        productsHtml.forEach(li => grid.appendChild(li));
      })
      .finally(() => {
        if (current_page_new < totalPages) {
          loadMoreBtn.removeAttribute("disabled");
          if (loadMoreText) loadMoreText.classList.remove('hide');
          if (loader) loader.classList.add('hide');
        }
        if (current_page_new >= totalPages) {
          if (loadMoreText) {
            loadMoreText.textContent = "Products Finished";
            loadMoreText.classList.remove('hide');
          }
          if (loader) loader.classList.add('hide');
        }
      });
  });
});







// jQuery(document).on("click", ".video_btn", function (e) {
  
//   // e.preventDefault();
//   let page = __st.p;


//   let sectionTitle = "Home Video Banner Slider";
//   let Buttontext = "shop bestsellers";

//   let data = {
//     section_name: sectionTitle,
//     button_name: Buttontext,
//     pagename: page,
//   };

//   let eventObj = {
//     eventName: "button_link",
//     eventData: data,
//   };
//   //console.log("------//------", eventObj);

//     Shopify.analytics.publish('percept_custom_event', eventObj);
// });



document.addEventListener("click", function(e) {
  const btn = e.target.closest(".video_btn");
  if (!btn) return;

  // e.preventDefault(); // Uncomment if you want to prevent default link behavior

  let page = window.__st && __st.p ? __st.p : "";

  let sectionTitle = "Home Video Banner Slider";
  let Buttontext = "shop bestsellers";

  let data = {
    section_name: sectionTitle,
    button_name: Buttontext,
    pagename: page,
  };

  let eventObj = {
    eventName: "button_link",
    eventData: data,
  };

  if (window.Shopify && Shopify.analytics) {
    Shopify.analytics.publish('percept_custom_event', eventObj);
  }
});




///////////////

// jQuery(document).on("click", ".best-sell-main .quick-add__submit", function (e) {
//   let page = __st.p;

//   let sectionTitle = jQuery(this)
//     .closest(".best-sell-main")
//     .find(".best-sell-title")
//     .text()
//     .trim();

  
//   let productTitle = jQuery(this)
//     .closest(".best_sell_li")
//     .find(".sec__card__content h3 a")
//     .text()
//     .trim();

  
//   let productType = jQuery(this)
//     .closest(".best_sell_li")
//     .find(".card__information.sec__card__information")
//     .data("pro-type"); 

//   let data = {
//     section_name: sectionTitle,
//     product_name: productTitle,
//     product_type: productType,
//     pagename: page,
//   };

//   let eventObj = {
//     eventName: "PRODUCT ADDED TO CART",
//     eventData: data,
//   };

//  // console.log("------//------", eventObj);
//     Shopify.analytics.publish('percept_custom_event', eventObj);
// });


document.addEventListener("click", function(e) {
  const btn = e.target.closest(".best-sell-main .quick-add__submit");
  if (!btn) return;

  let page = window.__st && __st.p ? __st.p : "";

  // Find the closest .best-sell-main ancestor and get its .best-sell-title text
  let bestSellMain = btn.closest(".best-sell-main");
  let sectionTitle = bestSellMain
    ? (bestSellMain.querySelector(".best-sell-title")?.textContent.trim() || "")
    : "";

  // Find the closest .best_sell_li ancestor and get product title and type
  let bestSellLi = btn.closest(".best_sell_li");
  let productTitle = bestSellLi
    ? (bestSellLi.querySelector(".sec__card__content h3 a")?.textContent.trim() || "")
    : "";

  let productType = bestSellLi
    ? (bestSellLi.querySelector(".card__information.sec__card__information")?.dataset.proType || "")
    : "";

  let data = {
    section_name: sectionTitle,
    product_name: productTitle,
    product_type: productType,
    pagename: page,
  };

  let eventObj = {
    eventName: "PRODUCT ADDED TO CART",
    eventData: data,
  };

  if (window.Shopify && Shopify.analytics) {
    Shopify.analytics.publish('percept_custom_event', eventObj);
  }
});


////////////////



// jQuery(document).on("click", ".best-sell-main .bottom_btn a", function (e) {
  

//   let page = __st.p;


//   let sectionTitle = "the crowd favourites";
//   let Buttontext = "explore all";

//   let data = {
//     section_name: sectionTitle,
//     button_name: Buttontext,
//     pagename: page,
//   };

//   let eventObj = {
//     eventName: "button_link",
//     eventData: data,
//   };
  
//   Shopify.analytics.publish('percept_custom_event', eventObj);
// });

document.addEventListener("click", function(e) {
  const btn = e.target.closest(".best-sell-main .bottom_btn a");
  if (!btn) return;

  let page = window.__st && __st.p ? __st.p : "";

  let sectionTitle = "the crowd favourites";
  let Buttontext = "explore all";

  let data = {
    section_name: sectionTitle,
    button_name: Buttontext,
    pagename: page,
  };

  let eventObj = {
    eventName: "button_link",
    eventData: data,
  };

  if (window.Shopify && Shopify.analytics) {
    Shopify.analytics.publish('percept_custom_event', eventObj);
  }
});






/////////////


// jQuery(document).on("click", ".collection_tab_main .quick-add__submit", function (e) {
//   let page = __st.p;

//   let sectionTitle = jQuery(this)
//     .closest(".collection_tab_main")
//     .find(".collection_tab_main_title")
//     .text()
//     .trim();

  
//   let productTitle = jQuery(this)
//     .closest(".badge_on")
//     .find(".sec__card__content h3 a")
//     .text()
//     .trim();

  
//   let productType = jQuery(this)
//     .closest(".badge_on")
//     .find(".card__information.sec__card__information")
//     .data("pro-type"); 

// let ActiveTabText = jQuery(this)
//     .closest(".collection_tab_inner")
//     .find(".collec_tab .swiper-slide a.swiper-slide-tab-link.active span")
//     .text()
//     .trim();

//   let data = {
//     section_name: sectionTitle,
//     product_name: productTitle,
//     product_type: productType,
//     pagename: page,
//     active_tab_text:ActiveTabText,
//   };

//   let eventObj = {
//     eventName: "PRODUCT ADDED TO CART",
//     eventData: data,
//   };

//  //console.log("------//------", eventObj);
//      Shopify.analytics.publish('percept_custom_event', eventObj);
// });

document.addEventListener("click", function(e) {
  const btn = e.target.closest(".collection_tab_main .quick-add__submit");
  if (!btn) return;

  let page = window.__st && __st.p ? __st.p : "";

  // Find the closest .collection_tab_main ancestor and get its .collection_tab_main_title text
  let collectionTabMain = btn.closest(".collection_tab_main");
  let sectionTitle = collectionTabMain
    ? (collectionTabMain.querySelector(".collection_tab_main_title")?.textContent.trim() || "")
    : "";

  // Find the closest .badge_on ancestor and get product title and type
  let badgeOn = btn.closest(".badge_on");
  let productTitle = badgeOn
    ? (badgeOn.querySelector(".sec__card__content h3 a")?.textContent.trim() || "")
    : "";

  let productType = badgeOn
    ? (badgeOn.querySelector(".card__information.sec__card__information")?.dataset.proType || "")
    : "";

  // Find the closest .collection_tab_inner ancestor and get active tab text
  let collectionTabInner = btn.closest(".collection_tab_inner");
  let activeTabText = "";
  if (collectionTabInner) {
    let activeTab = collectionTabInner.querySelector(".collec_tab .swiper-slide a.swiper-slide-tab-link.active span");
    if (activeTab) activeTabText = activeTab.textContent.trim();
  }

  let data = {
    section_name: sectionTitle,
    product_name: productTitle,
    product_type: productType,
    pagename: page,
    active_tab_text: activeTabText,
  };

  let eventObj = {
    eventName: "PRODUCT ADDED TO CART",
    eventData: data,
  };

  if (window.Shopify && Shopify.analytics) {
    Shopify.analytics.publish('percept_custom_event', eventObj);
  }
});


// jQuery(document).on("click", ".tab_product_main .bottom_btn a", function (e) {
//    //e.preventDefault();
//   let page = __st.p;


//   let sectionTitle = "curate your hair care";
//   let Buttontext = "Explore all";

//   let ActiveTabText = jQuery(this)
//     .closest(".collection_tab_inner")
//     .find(".collec_tab .swiper-slide a.swiper-slide-tab-link.active span")
//     .text()
//     .trim();

//   let data = {
//     section_name: sectionTitle,
//     button_name: Buttontext,
//     pagename: page,
//     active_tab_text:ActiveTabText,
//   };

  

//   let eventObj = {
//     eventName: "button_link",
//     eventData: data,
//   };
//   //console.log("------//------", eventObj);

//     Shopify.analytics.publish('percept_custom_event', eventObj);
// });


document.addEventListener("click", function(e) {
  const btn = e.target.closest(".tab_product_main .bottom_btn a");
  if (!btn) return;

  // e.preventDefault(); // Uncomment if you want to prevent default link behavior

  let page = window.__st && __st.p ? __st.p : "";

  let sectionTitle = "curate your hair care";
  let Buttontext = "Explore all";

  // Find the closest .collection_tab_inner ancestor and get active tab text
  let collectionTabInner = btn.closest(".collection_tab_inner");
  let activeTabText = "";
  if (collectionTabInner) {
    let activeTab = collectionTabInner.querySelector(".collec_tab .swiper-slide a.swiper-slide-tab-link.active span");
    if (activeTab) activeTabText = activeTab.textContent.trim();
  }

  let data = {
    section_name: sectionTitle,
    button_name: Buttontext,
    pagename: page,
    active_tab_text: activeTabText,
  };

  let eventObj = {
    eventName: "button_link",
    eventData: data,
  };

  if (window.Shopify && Shopify.analytics) {
    Shopify.analytics.publish('percept_custom_event', eventObj);
  }
});


// jQuery(document).on("click", ".quiz-left-inner a", function (e) {
//    //e.preventDefault();
//   let page = __st.p;


//   let sectionTitle = "Quiz Section";
//   let Buttontext = "take the quiz";

 

//   let data = {
//     section_name: sectionTitle,
//     button_name: Buttontext,
//     pagename: page,
   
//   };

  

//   let eventObj = {
//     eventName: "button_link",
//     eventData: data,
//   };
//   //console.log("------//------", eventObj);

//     Shopify.analytics.publish('percept_custom_event', eventObj);
// });

document.addEventListener("click", function(e) {
  const btn = e.target.closest(".quiz-left-inner a");
  if (!btn) return;

  // e.preventDefault(); // Uncomment if you want to prevent default link behavior

  let page = window.__st && __st.p ? __st.p : "";

  let sectionTitle = "Quiz Section";
  let Buttontext = "take the quiz";

  let data = {
    section_name: sectionTitle,
    button_name: Buttontext,
    pagename: page,
  };

  let eventObj = {
    eventName: "button_link",
    eventData: data,
  };

  if (window.Shopify && Shopify.analytics) {
    Shopify.analytics.publish('percept_custom_event', eventObj);
  }
});



// jQuery(document).on("click", ".custom-banner a", function (e) {
//    //e.preventDefault();
//   let page = __st.p;


//   let sectionTitle = "THE MOXIE MAKER - About-us";
  

//   let data = {
//     section_name: sectionTitle,
//     pagename: page,
//   };

  

//   let eventObj = {
//     eventName: "button_link",
//     eventData: data,
//   };
//   //console.log("------//------", eventObj);

//     Shopify.analytics.publish('percept_custom_event', eventObj);
// });





/////////////////


document.addEventListener("click", function(e) {
  const btn = e.target.closest(".custom-banner a");
  if (!btn) return;

  // e.preventDefault(); // Uncomment if you want to prevent default link behavior

  let page = window.__st && __st.p ? __st.p : "";

  let sectionTitle = "THE MOXIE MAKER - About-us";

  let data = {
    section_name: sectionTitle,
    pagename: page,
  };

  let eventObj = {
    eventName: "button_link",
    eventData: data,
  };

  if (window.Shopify && Shopify.analytics) {
    Shopify.analytics.publish('percept_custom_event', eventObj);
  }
});

// jQuery(document).on("click", ".sample_product .quick-add__submit", function (e) {
//   let page = __st.p;

//   let sectionTitle = "CLAIM YOUR TWO FREE MINIS!"

  
//   let productTitle = jQuery(this)
//     .closest(".product-card-wrapper")
//     .find(".sec__card__content h3 a")
//     .text()
//     .trim();

  
//   let productType = jQuery(this)
//     .closest(".product-card-wrapper")
//     .find(".card__information.sec__card__information")
//     .data("pro-type"); 

//   let data = {
//     section_name: sectionTitle,
//     product_name: productTitle,
//     product_type: productType,
//     pagename: page,
//   };

//   let eventObj = {
//     eventName: "PRODUCT ADDED TO CART",
//     eventData: data,
//   };

//   //console.log("------//------", eventObj);
//     Shopify.analytics.publish('percept_custom_event', eventObj);
// });


document.addEventListener("click", function(e) {
  const btn = e.target.closest(".sample_product .quick-add__submit");
  if (!btn) return;

  let page = window.__st && __st.p ? __st.p : "";

  let sectionTitle = "CLAIM YOUR TWO FREE MINIS!";

  // Find the closest .product-card-wrapper ancestor and get product title and type
  let productCard = btn.closest(".product-card-wrapper");
  let productTitle = productCard
    ? (productCard.querySelector(".sec__card__content h3 a")?.textContent.trim() || "")
    : "";

  let productType = productCard
    ? (productCard.querySelector(".card__information.sec__card__information")?.dataset.proType || "")
    : "";

  let data = {
    section_name: sectionTitle,
    product_name: productTitle,
    product_type: productType,
    pagename: page,
  };

  let eventObj = {
    eventName: "PRODUCT ADDED TO CART",
    eventData: data,
  };

  if (window.Shopify && Shopify.analytics) {
    Shopify.analytics.publish('percept_custom_event', eventObj);
  }
});




////////
// jQuery(document).on("click", ".CT_cart_product_secend .quick-add__submit", function (e) {
//   let page = __st.p;

//   let sectionTitle = "COMPLETE YOUR ROUTINE"

  
//   let productTitle = jQuery(this)
//     .closest(".product-card-wrapper")
//     .find(".sec__card__content h3 a")
//     .text()
//     .trim();

  
//   let productType = jQuery(this)
//     .closest(".product-card-wrapper")
//     .find(".card__information.sec__card__information")
//     .data("pro-type"); 

//   let data = {
//     section_name: sectionTitle,
//     product_name: productTitle,
//     product_type: productType,
//     pagename: page,
//   };

//   let eventObj = {
//     eventName: "PRODUCT ADDED TO CART",
//     eventData: data,
//   };

//   //console.log("------//------", eventObj);
//     Shopify.analytics.publish('percept_custom_event', eventObj);
// });

document.addEventListener("click", function(e) {
  const btn = e.target.closest(".CT_cart_product_secend .quick-add__submit");
  if (!btn) return;

  let page = window.__st && __st.p ? __st.p : "";

  let sectionTitle = "COMPLETE YOUR ROUTINE";

  // Find the closest .product-card-wrapper ancestor and get product title and type
  let productCard = btn.closest(".product-card-wrapper");
  let productTitle = productCard
    ? (productCard.querySelector(".sec__card__content h3 a")?.textContent.trim() || "")
    : "";

  let productType = productCard
    ? (productCard.querySelector(".card__information.sec__card__information")?.dataset.proType || "")
    : "";

  let data = {
    section_name: sectionTitle,
    product_name: productTitle,
    product_type: productType,
    pagename: page,
  };

  let eventObj = {
    eventName: "PRODUCT ADDED TO CART",
    eventData: data,
  };

  if (window.Shopify && Shopify.analytics) {
    Shopify.analytics.publish('percept_custom_event', eventObj);
  }
});




///////////// Collection page 


// jQuery(document).on("click", ".Collection-link li a", function (e) {
//    //e.preventDefault();
//   let page = __st.p;

//   let Collection_switch_button_text = jQuery(this).find("span").text().trim();

//   let collectionTitle = jQuery(".ct_collection_main").attr("collection_title") || "";

//   let data = {
//     Collection_switch_button_text: Collection_switch_button_text,
//     pagename: page,
//     collection_title: collectionTitle
//   };

//   let eventObj = {
//     eventName: "Collection_switch_button",
//     eventData: data,
//   };

//   //console.log("------//------", eventObj);

//    Shopify.analytics.publish('percept_custom_event', eventObj);
// });


document.addEventListener("click", function(e) {
  const btn = e.target.closest(".Collection-link li a");
  if (!btn) return;

  // e.preventDefault(); // Uncomment if you want to prevent default link behavior

  let page = window.__st && __st.p ? __st.p : "";

  // Get the text inside the <span> within the clicked link
  let Collection_switch_button_text = btn.querySelector("span") 
    ? btn.querySelector("span").textContent.trim() 
    : "";

  // Get the collection title from the .ct_collection_main element
  let collectionTitle = document.querySelector(".ct_collection_main")?.getAttribute("collection_title") || "";

  let data = {
    Collection_switch_button_text: Collection_switch_button_text,
    pagename: page,
    collection_title: collectionTitle
  };

  let eventObj = {
    eventName: "Collection_switch_button",
    eventData: data,
  };

  if (window.Shopify && Shopify.analytics) {
    Shopify.analytics.publish('percept_custom_event', eventObj);
  }
});




//////////////

// jQuery(document).on("click", ".ct_collection_main .quick-add__submit", function (e) {
//   let page = __st.p;
//   let collectionTitle = jQuery(".ct_collection_main").attr("collection_title") || "";
//   let productTitle = jQuery(this)
//     .closest(".grid__item")
//     .find(".sec__card__content h3 a")
//     .text()
//     .trim();

//   let productType = jQuery(this)
//     .closest(".grid__item")
//     .find(".card__information.sec__card__information")
//     .data("pro-type"); 

//   let data = {
//     collection_title: collectionTitle,
//     product_name: productTitle,
//     product_type: productType,
//     pagename: page,
//   };

//   let eventObj = {
//     eventName: "PRODUCT ADDED TO CART",
//     eventData: data,
//   };

//   //console.log("------//------", eventObj);
//     Shopify.analytics.publish('percept_custom_event', eventObj);
// });

document.addEventListener("click", function(e) {
  const btn = e.target.closest(".ct_collection_main .quick-add__submit");
  if (!btn) return;

  let page = window.__st && __st.p ? __st.p : "";

  // Get the collection title from the .ct_collection_main element
  let collectionTitle = document.querySelector(".ct_collection_main")?.getAttribute("collection_title") || "";

  // Find the closest .grid__item ancestor and get product title and type
  let gridItem = btn.closest(".grid__item");
  let productTitle = gridItem
    ? (gridItem.querySelector(".sec__card__content h3 a")?.textContent.trim() || "")
    : "";

  let productType = gridItem
    ? (gridItem.querySelector(".card__information.sec__card__information")?.dataset.proType || "")
    : "";

  let data = {
    collection_title: collectionTitle,
    product_name: productTitle,
    product_type: productType,
    pagename: page,
  };

  let eventObj = {
    eventName: "PRODUCT ADDED TO CART",
    eventData: data,
  };

  if (window.Shopify && Shopify.analytics) {
    Shopify.analytics.publish('percept_custom_event', eventObj);
  }
});



//////////
// jQuery(document).on("click", "#FacetsWrapperDesktop details ul li label", function (e) {
  
//   let page = __st.p;

  
//   let filter_text = jQuery(this).find(".ct_filter_text").text().trim();

 
//   let collectionTitle = jQuery(".ct_collection_main").attr("collection_title") || "";

 
//   let Filter_main_label = jQuery(this)
//     .closest(".ct_filter_main")
//     .find(".ct_filter_label")
//     .text()
//     .trim();

//   let data = {
//     filter_text: filter_text,
//     pagename: page,
//     collection_title: collectionTitle,
//     filter_main_label: Filter_main_label,
//   };

//   let eventObj = {
//     eventName: "Collection_filter",
//     eventData: data,
//   };

//   console.log("------//------", eventObj);
// });




// jQuery(document).off("click", ".custom_comp .quick-add__submit").on("click", ".custom_comp .quick-add__submit", function (e) {
//   let page = __st.p;

//   let sectionTitle = "Upgrade your routine - Product details";

//   let productTitle = jQuery(this)
//     .closest(".complementary-slide")
//     .find(".sec__card__content h3 a")
//     .text()
//     .trim();

//   let productType = jQuery(this)
//     .closest(".complementary-slide")
//     .find(".card__information.sec__card__information")
//     .data("pro-type"); 

//   let data = {
//     section_name: sectionTitle,
//     product_name: productTitle,
//     product_type: productType,
//     pagename: page,
//   };

//   let eventObj = {
//     eventName: "PRODUCT ADDED TO CART",
//     eventData: data,
//   };

//   //console.log("------//------", eventObj);
//    Shopify.analytics.publish('percept_custom_event', eventObj);
// });


document.addEventListener("click", function(e) {
  const btn = e.target.closest(".custom_comp .quick-add__submit");
  if (!btn) return;

  let page = window.__st && __st.p ? __st.p : "";

  let sectionTitle = "Upgrade your routine - Product details";

  // Find the closest .complementary-slide ancestor and get product title and type
  let compSlide = btn.closest(".complementary-slide");
  let productTitle = compSlide
    ? (compSlide.querySelector(".sec__card__content h3 a")?.textContent.trim() || "")
    : "";

  let productType = compSlide
    ? (compSlide.querySelector(".card__information.sec__card__information")?.dataset.proType || "")
    : "";

  let data = {
    section_name: sectionTitle,
    product_name: productTitle,
    product_type: productType,
    pagename: page,
  };

  let eventObj = {
    eventName: "PRODUCT ADDED TO CART",
    eventData: data,
  };

  if (window.Shopify && Shopify.analytics) {
    Shopify.analytics.publish('percept_custom_event', eventObj);
  }
});